import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button/Button";
import Stack from "@mui/material/Stack/Stack";
import { createListCollection } from "@ark-ui/react";
import { useField, useForm } from "react-final-form";

import OrderListButton from "@/features/admin/components/order-list-button/OrderListButton";
import { Threshold } from "@/features/widget-forms/forms/line-graph-form";
import { TextField } from "@/features/shared/components";
import Select from "@/components/select/select";
import { useTranslation } from "@/lib/i18n";

interface ThresholdsConfigurationProps {
  index: number;
  name: string;
  initialValues: Threshold[];
  defaultValues: Threshold;
  removeThreshold: (index: number) => void;
  thresholds: Threshold[];
}

const ThresholdsConfiguration = ({
  index,
  name,
  initialValues,
  defaultValues,
  removeThreshold,
  thresholds,
}: ThresholdsConfigurationProps) => {
  const { t } = useTranslation();
  const form = useForm();

  const typeField = useField(`${name}[${index}].threshold_type`, {
    defaultValue: initialValues?.[index].threshold_type ?? defaultValues.threshold_type,
  });
  const typeCollection = createListCollection({
    items: [
      {
        label: "Max",
        value: "max",
      },
      {
        label: "Min",
        value: "min",
      },
      {
        label: "Line",
        value: "line",
      },
    ],
  });

  const colorOptions = ["red", "orange"] as const;
  const colorField = useField(`${name}[${index}].color`, {
    defaultValue: initialValues?.[index].color ?? defaultValues.color,
  });
  const colorCollection = createListCollection({
    items: colorOptions.map((c) => ({
      label: t(`admin.widgets.fields.lineGraph.thresholds.colors.${c}`),
      value: c,
    })),
  });

  return (
    <div>
      <Stack direction="row" gap={1}>
        <OrderListButton name={name} list={thresholds} index={index} />
        <TextField
          name={`${name}[${index}].title`}
          label="Threshold name"
          defaultValue={initialValues?.[index].title ?? defaultValues.title}
          sx={{ mt: 0 }}
        />
        <TextField
          type="number"
          name={`${name}[${index}].value`}
          label="Value"
          defaultValue={initialValues?.[index].value ?? defaultValues.value}
          sx={{ mt: 0 }}
          required
        />
        <Select
          name={typeField.input.name}
          label="Type"
          collection={typeCollection}
          error={typeField.meta.touched && typeField.meta.error}
          value={typeField.input.value}
          onValueChange={(value) => form.change(typeField.input.name, value)}
        />
        <Select
          name={colorField.name}
          label="Kleur"
          collection={colorCollection}
          error={colorField.meta.touched && colorField.meta.error}
          value={colorField.input.value}
          onValueChange={(value) => form.change(colorField.input.name, value)}
        />

        <Button
          onClick={() => removeThreshold(index)}
          sx={{ minWidth: 0, alignSelf: "flex-start", mt: 2 }}
        >
          <CloseIcon fontSize="small" />
        </Button>
      </Stack>
    </div>
  );
};

export default ThresholdsConfiguration;
